module.exports = __webpack_public_path__ + "static/media/4.2a733b42.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_41/images/九宫格未选中态/4.png
// module id = 944
// module chunks = 0